import { CommonTag, TagType } from '../../../../components/tag';
import getFormatMessage from '../../../../locales/get-format-message';
import { NoticeSystemStatus } from '../../../../model/api-modules';
import { store } from '../../../../store';

export const NOTICE_STATUS_OPTIONS = [
  {
    label: getFormatMessage('view_all'),
    value: NoticeSystemStatus.Default,
  },
  {
    label: getFormatMessage('notice_pending_approval'),
    value: NoticeSystemStatus.PendingApproval,
  },
  {
    label: getFormatMessage('notice_pending_update'),
    value: NoticeSystemStatus.PendingUpdate,
  },
  {
    label: getFormatMessage('notice_draft'),
    value: NoticeSystemStatus.Draft,
  },
  {
    label: getFormatMessage('notice_wait_publish'),
    value: NoticeSystemStatus.PendingPublic,
  },
  {
    label: getFormatMessage('notice_status_publish'),
    value: NoticeSystemStatus.Published,
  },
];

export const renderStatusTag = (status: NoticeSystemStatus) => {
  const tagMap: Record<NoticeSystemStatus, { color: TagType; text: string }> = {
    [NoticeSystemStatus.Default]: {
      color: 'blue',
      text: getFormatMessage('notice_draft'),
    },
    [NoticeSystemStatus.Draft]: {
      color: 'blue',
      text: getFormatMessage('notice_draft'),
    },
    [NoticeSystemStatus.PendingApproval]: {
      color: 'pink',
      text: getFormatMessage('notice_pending_approval'),
    },
    [NoticeSystemStatus.PendingUpdate]: {
      color: 'pink',
      text: getFormatMessage('notice_pending_update'),
    },
    [NoticeSystemStatus.PendingPublic]: {
      color: 'yellow',
      text: getFormatMessage('notice_wait_publish'),
    },
    [NoticeSystemStatus.Published]: {
      color: 'green',
      text: getFormatMessage('notice_status_publish'),
    },
  };

  const tagConfig = tagMap[status];
  if (tagMap) {
    return <CommonTag type={tagConfig.color} text={tagConfig.text} />;
  }

  return null;
};

export const hasAuthPerm = () => {
  const { userInfo } = store.getState().common;
  if (!userInfo) {
    return false;
  }

  return [
    'joeyyihuang@tencent.com',
    'franklong@tencent.com',
    'disonleng@tencent.com',
  ].includes(userInfo.UserID);
};
